import styled from "styled-components";
import InputNumber from "../../components/InputNumber";
import { Body1, Heading6 } from "../../components/Typography";
import { COLOR_WHITE } from "../../constants/colors";

type QtyInputProps = {
  isAvailable: boolean;
  qty: number;
  setQty: (value: number) => void;
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  ${Heading6}
  width: 100px;
  color: ${COLOR_WHITE};
  flex-shrink: 0;

  @media (max-width: 1140px) {
    width: 100px;
  }

  @media (max-width: 576px) {
    width: 65px;
  }
`;

const OutOfStock = styled.div`
  ${Body1}
  color: ${COLOR_WHITE};
`;

function QtyInput(props: QtyInputProps) {
  const { isAvailable, qty, setQty } = props;

  return (
    <Container>
      <Title>Qty:</Title>
      {isAvailable ? <InputNumber value={qty} onChange={setQty} /> : <OutOfStock>OUT OF STOCK</OutOfStock>}
    </Container>
  );
}

export default QtyInput;
